import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type useProductPricesProps<T> = {
  filters?: {
    search?: string;
    productCategoryId?: string;
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useProductPrices = <T,>({
  filters: { search = '', productCategoryId, page = 1 } = {},
  mapper = Mapper.default<T>(),
}: useProductPricesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['productsPrices', search, productCategoryId, page],
    queryFn: () => {
      return privateAxios.get('/product_prices', {
        params: {
          search,
          'q[filter_by_product_category_id_eq]': productCategoryId,
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
